<template>
  <div class="fixed inset-0 z-50 grid place-items-center bg-slate-950/55 px-4 py-6" role="dialog" aria-modal="true" aria-label="Share flyer" @click.self="$emit('close')">
    <section class="w-full max-w-sm overflow-hidden rounded-2xl bg-white shadow-2xl">
      <header class="flex items-center justify-between border-b border-slate-200 px-4 py-3">
        <div>
          <h2 class="m-0 text-lg font-black text-slate-950">Share flyer</h2>
          <p class="m-0 mt-1 text-xs font-bold text-slate-500">{{ flyer.category || 'NetFlyr' }}</p>
        </div>
        <button class="grid h-9 w-9 place-items-center rounded-full text-slate-500 hover:bg-slate-100 hover:text-slate-950" type="button" aria-label="Close share modal" @click="$emit('close')">
          <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.3" aria-hidden="true">
            <path d="M18 6 6 18M6 6l12 12" />
          </svg>
        </button>
      </header>

      <div class="grid gap-4 p-4">
        <div class="rounded-2xl border border-slate-200 bg-slate-50 p-3">
          <p class="m-0 line-clamp-2 text-sm font-black text-slate-950">{{ sharePreviewTitle }}</p>
          <p class="m-0 mt-1 truncate text-xs font-bold text-slate-500">{{ shareUrl }}</p>
        </div>

        <div class="grid grid-cols-2 gap-3">
          <button class="share-action" type="button" @click="copyLink">Copy link</button>
          <a class="share-action" :href="whatsappUrl" target="_blank" rel="noopener noreferrer">WhatsApp</a>
        </div>

        <p v-if="message" class="m-0 rounded-xl bg-emerald-50 px-3 py-2 text-sm font-bold text-emerald-700">{{ message }}</p>
      </div>
    </section>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'

const props = defineProps({
  flyer: { type: Object, required: true }
})

defineEmits(['close'])

const message = ref('')
const shareUrl = computed(() => props.flyer.shareUrl || props.flyer.share_url || `${window.location.origin}/flyers/${props.flyer.id}`)
const stripHtml = (value = '') =>
  String(value || '')
    .replace(/<br\s*\/?>/gi, ' ')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/\s+/g, ' ')
    .trim()
const sharePreviewTitle = computed(() => props.flyer.title || stripHtml(props.flyer.description) || props.flyer.category || 'Flyer')
const whatsappUrl = computed(() => `https://wa.me/?text=${encodeURIComponent(shareUrl.value)}`)

const copyLink = async () => {
  try {
    await navigator.clipboard.writeText(shareUrl.value)
    message.value = 'Link copied.'
  } catch {
    message.value = shareUrl.value
  }
}
</script>

<style scoped>
.share-action {
  display: inline-flex;
  min-height: 2.75rem;
  align-items: center;
  justify-content: center;
  border-radius: 0.9rem;
  background: rgb(37 99 235);
  padding: 0 1rem;
  text-align: center;
  font-size: 0.85rem;
  font-weight: 900;
  color: white;
}

.line-clamp-2 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
</style>
